
import { defineComponent, onMounted } from 'vue';
import WmsLogs from '../components/WmsLogs.vue';
import { setPageHeader } from '@/core/helpers/toolbar';

export default defineComponent({
    components: {
        WmsLogs
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: 'message.WMS_LOGS',
                actionButton: null,
                breadCrumbs: [{ name: 'message.HOME', link: '/dashboard' }, { name: 'message.SYSTEM', link: '#' }, { name: 'message.WMS', link: '/system/wms' }, { name: 'message.WMS_LOGS' }]
            });
        });
    }
});
